export const getCableFromPartNumber = (partNumber: string) => {
  if (!partNumber.startsWith('OHFT-') && !partNumber.startsWith('OHFJ-') && !partNumber.startsWith('CJ-')) {
    throw new Error('Only OHFT, OHFJ and CJ families are supported');
  }

  return partNumber.split('-')[1];
};

export const getIsoDate = (date: Date | string | number): string => {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date);
  }
  const fullMonth = String(date.getMonth() + 1).padStart(2, '0');
  const fullDay = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${fullMonth}-${fullDay}`;
};
